import { useContext } from 'react';
import { AuthContext } from '../providers/AuthProvider';
import { ACCESS_TOKEN } from '../utils/constants';
import { logout } from '../api/auth';

if (localStorage.getItem(ACCESS_TOKEN) === 'undefined') logout();
export default () => useContext(AuthContext);
